import { Header, Wrapper, StyledTable, TableHeader, TableCell, TableRow, Info, SubHeader, LinkWrapper, AddressLink, ContactWrapper, ContactSection, ContactInfo, PhoneIcon, MailIcon, PinIcon, TourIcon, } from "../styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { useTranslation } from "react-i18next";
import { PRICE_TABLES } from "./priceTable.config";

const LinkIcon = ({ kind }) => {
    if (kind === "phone") return <PhoneIcon />;
    if (kind === "email") return <MailIcon />;
    if (kind === "maps") return <PinIcon />;
    if (kind === "tour") return <TourIcon />;
    return null;
};

const PriceTable = ({ variant }) => {
    const { t } = useTranslation("priceList");

    const cfg = PRICE_TABLES[variant];
    if (!cfg) return null;

    const columns = cfg.columns;
    const rows = cfg.rows;
    const IconMap = cfg.icons;

    return (
        <Wrapper id={cfg.wrapperId}>
            <StaggeredContainer>
                <StaggeredItem>
                    <Header>{t(cfg.titleKey)}</Header>
                </StaggeredItem>

                <StaggeredItem>
                    <StyledTable>
                        <thead>
                            <TableRow>
                                <TableHeader />
                                <TableHeader />
                                {columns.map((col) => (
                                    <TableHeader key={col.key}>{t(col.labelKey)}</TableHeader>
                                ))}
                            </TableRow>
                        </thead>

                        <tbody>
                            {rows.map((row) => {
                                const Icon = IconMap[row.icon];

                                return (
                                    <TableRow key={row.key}>
                                        <TableCell data-kind="type" data-label={t("common.columns.type")}>
                                            <span className="cellValue">{t(`${variant}.rows.${row.key}`)}</span>
                                        </TableCell>
                                        <TableCell data-kind="icon" data-label={t("common.columns.icon")}>
                                            {Icon ? <Icon /> : null}
                                        </TableCell>
                                        {row.values.map((val, idx) => (
                                            <TableCell
                                                key={`${row.key}-${columns[idx].key}`}
                                                data-kind="value"
                                                data-col={columns[idx].key}
                                                data-empty={val === "-" ? "true" : "false"}
                                                data-label={t(columns[idx].labelKey)}
                                            >
                                                <span className="cellValue">{val}</span>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                        </tbody>
                    </StyledTable>
                </StaggeredItem>

                {cfg.notes?.linesKeys?.length ? (
                    <StaggeredItem>
                        <Info>
                            {cfg.notes.linesKeys.map((k, i) => {
                                const line = t(k);
                                const isStrong = i === cfg.notes.strongLineIndex;

                                return (
                                    <span key={k}>
                                        {isStrong ? <strong>{line}</strong> : line}
                                        <br />
                                    </span>
                                );
                            })}
                        </Info>
                    </StaggeredItem>
                ) : null}

                {cfg.contactBlocks?.length ? (
                    <StaggeredItem>
                        <ContactWrapper>
                            {cfg.contactBlocks.map((block, idx) => (
                                <ContactSection key={`${variant}-block-${idx}`}>
                                    <SubHeader>{t(block.headerKey)}</SubHeader>

                                    {block.textKey ? <ContactInfo>{t(block.textKey)}</ContactInfo> : null}

                                    {block.textKeys ? (
                                        <ContactInfo>
                                            {block.textKeys.map((tk) => (
                                                <span key={tk}>
                                                    {t(tk)}
                                                    <br />
                                                </span>
                                            ))}

                                            {block.type !== "contact" && block.links?.length ? (
                                                block.links.map((lnk) => (
                                                    <LinkWrapper key={lnk.href}>
                                                        <AddressLink
                                                            href={lnk.href}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            title={t("common.titles.mapsTitle")}
                                                        >
                                                            <LinkIcon kind={lnk.kind} />
                                                            {t(lnk.labelKey)}
                                                        </AddressLink>
                                                    </LinkWrapper>
                                                ))
                                            ) : null}
                                        </ContactInfo>
                                    ) : null}

                                    {block.type === "contact" && block.links?.length
                                        ? block.links.map((lnk) => (
                                            <LinkWrapper key={lnk.href}>
                                                <AddressLink href={lnk.href} title={t("common.titles.phoneTitle")}>
                                                    <LinkIcon kind={lnk.kind} /> {t(lnk.displayKey)}
                                                </AddressLink>
                                            </LinkWrapper>
                                        ))
                                        : null}
                                </ContactSection>
                            ))}
                        </ContactWrapper>
                    </StaggeredItem>
                ) : null}
            </StaggeredContainer>
        </Wrapper>
    );
};

export default PriceTable;